import { clone, isArray } from 'lodash';

export const processGetFormResponseData = data => {
  const result = {
    options: {
      ...data.options,
      Date: {
        ...data.options.Date,
        year: Object.values(data.options.Date.year).sort(
          (a, b) => Number(b.value) - Number(a.value)
        ),
      },
    },
  };

  if (data.hasOwnProperty('isRecruiter')) {
    result.isRecruiter = data.isRecruiter;
  }

  if (data.fields && data.fields.DegreeID) {
    result.fields = {
      ...data.fields,
      CurrentSchoolID:
        data.fields.CurrentSchoolID && data.fields.CurrentSchoolID.value === -2
          ? {
              ...data.fields.CurrentSchoolID,
              __isNew__: true,
            }
          : data.fields.CurrentSchoolID,
      RoleID: result.options.RoleID.find(
        role => role.value === data.fields.RoleID
      ),
      DegreeID: result.options.DegreeID.find(
        degree => degree.value === data.fields.DegreeID
      ),
      startDate:
        data.fields.StartMonth && data.fields.StartYear
          ? {
              month: data.fields.StartMonth,
              year: data.fields.StartYear,
            }
          : null,
      endDate:
        data.fields.EndMonth && data.fields.EndYear
          ? {
              month: data.fields.EndMonth,
              year: data.fields.EndYear,
            }
          : null,
      Present: Number(data.fields.Present) === 1,
    };
  }

  return result;
};

export const processPostFormRequestData = (data, su = false) => {
  const result = clone(data);

  for (const field in result) {
    let data = result[field];

    if (
      data === null ||
      (field === 'Active' && !(su && result.Present === 1)) ||
      (!su &&
        [
          'Approved',
          'AddNewsfeedItem',
          'SendEmail',
          'SendDeclineEmail',
        ].includes(field))
    ) {
      delete result[field];
    } else if (
      [
        'Active',
        'AddNewsfeedItem',
        'SendEmail',
        'SendDeclineEmail',
        'Present',
      ].includes(field)
    ) {
      result[field] = data ? 1 : 0;
    } else if (field === 'startDate') {
      result.StartMonth = data.month;
      result.StartYear = data.year;
    } else if (field === 'endDate') {
      if (!result.Present) {
        result.EndMonth = data.month;
        result.EndYear = data.year;
      }
    } else if (field === 'CurrentSchoolID' && data.__isNew__) {
      result.CurrentSchoolID = -2;
      result.CurrentSchoolOther = data.label;
    } else if (isArray(data)) {
      result[field] = data.map(item => item.id);
    } else if (typeof data === 'object') {
      result[field] = data.value;
    }
  }

  delete result.startDate;
  delete result.endDate;

  return result;
};
